import * as Sentry from '@sentry/angular';

export function initSentry(dsn: string, environment: string, recordReplays: boolean): void {
    Sentry.init({
        dsn,
        environment,
        
        // Performance monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
        
        // Session replay (optional but recommended)
        replaysSessionSampleRate: recordReplays ? 1 : 0,
        replaysOnErrorSampleRate: recordReplays ? 1 : 0,
        
        // Release tracking
        release: `frontend@${environment}`,
        enableLogs: true,

        // Integrations
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false, // Don't mask text (you can enable if needed for privacy)
                blockAllMedia: false, // Don't block media
            }),
        ],
        
        // Before sending event to Sentry
        beforeSend(event, hint) {            
            // Add release context to events
            if (!event.release) {
                event.release = `frontend@${environment}`;
            }
            
            return event;
        },
        
        // Ignore specific errors
        ignoreErrors: [
            // Ignore network errors
            'NetworkError',
            'Failed to fetch',
            'Network request failed',
            'ChunkLoadError',
            
            // Ignore browser extensions
            'ResizeObserver loop limit exceeded',
            'Non-Error promise rejection captured',
            
            // Ignore user aborted requests
            'AbortError',
            
            // Ignore RxJS EmptyError (usually handled gracefully)
            'EmptyError',
        ],
    });
}

